import { AddZoneComponent } from './add-zone/add-zone.component';
import { EditZoneComponent } from './edit-zone/edit-zone.component';
import { ViewZoneListComponent } from './view-zone-list/view-zone-list.component';
import { ViewZoneComponent } from './view-zone/view-zone.component';    

export const ZoneModuleDeclaration = [
    AddZoneComponent,
    EditZoneComponent,
    ViewZoneComponent,
    ViewZoneListComponent
];